import { client } from './client'
import type { AgentProviderModels } from '@/types'

export const agentProvidersApi = {
  getModels: () =>
    client.get<AgentProviderModels[]>('/agent-providers/models').then(r => r.data),
}
